import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { GRAPHQL_AUTH_MODE, GraphQLOptions } from '@aws-amplify/api-graphql';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor() { }


  async authenticateViberID(
    token: string
  ): Promise<any> {
    const statement = `    
mutation viberAuth($token: String!) {
    authenticateViberID(token: $token) {
      city
      address
      company
      createdAt
      email
      expirationDate
      firstName
      id
      lastName
      isVatIncluded
      phone
      status
      totalScanCount
      updatedAt
      username
      userID
      viberID
    }
  }
  `;
    const gqlOptions : GraphQLOptions =  {
        query: statement,
        variables: {
            token
        },
        authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
    }
    const response = (await API.graphql(
        gqlOptions
    )) as any;
    console.log('response', response)
    if (response.errors){ 
        console.log('errors', response.errors)
        return
    }
    return response.data.authenticateViberID;
  }
}
